import { createSlice } from "@reduxjs/toolkit"
import { revertAllSuperAdmin } from "../actions/user"

const initialState = {
  totalUserCount: 0,
  totalActiveUser: 0,
  frontlineUser: {
    id: null,
    frontlineUserData: {},
    frontlineUserList: {
      totalPages: 1,
      data: []
    }
  },
  notifications: {
    id: null,
    notificationData: {},
    notificationList: {
      totalPages: 1,
      data: []
    },
    notificationImageId: ""
  },
  adminUsers: {
    id: null,
    isFormSubmitted: false,
    adminUserData: {},
    adminUserList: {
      totalPages: 1,
      data: {}
    }
  },
  versionListData: {
    totalPages: 1,
    data: {}
  },
  versionData: {},
  versionId: null,
  dashboardStats: {},
  giftCards: {
    id: null,
    giftCardData: {},
    giftCardList: {
      totalPages: 1,
      data: []
    },
    giftCardImageId: ""
  },
  gamificationData: {},
  eventList: [],
  eventID: null,
  eventDetails: {},
  menuImageList: [],
  menuImages: [],
  downloadMenuTemplate: "",
  menuFields: [],
  nonAiFields: [],
  userRole: [],
  userRoleList: [],
  userRoleId: null,
  roleDetails: {},
  menuCategoryDetails: [],
  recommendationCategoryList: [],
  recommendedCategoryDetails: {},
  headerNotificationData: {},
  tilesList: [],
  tileDetails: {},
  weeklyCategory: [],
  weeklyCategoryImage: { image: "", icon: "" },
  advertisements: [],
  advertisementDetails: {},
  advertisementId: null,
  privacyPolicy: [],
  notableVips: {
    data: [],
    count: 0
  },
  notableVipGroups: [],
  notableUsers: [],
  rewardsPermissions: [],
  selectedVipDetails: {},
  vipImageIds: {},
  notableGroupTypeId: "",
  avataarPrompt: [],
  avataarEnabled: true,
  schemaFields: [],
  tiers: [],
  downgradeEnabled: false,
  categories: [],
  cardTypes: [],
  rewards: [],
  rewardsSpreeActive: false,
  spreeWindowData: null,
  redemptions: [],
  giftCardRedemptions: [],
  rewardState: {},
  shoppingSpreeWindows: [],
  analytics: {
    total_cards: 0,
    total_redemption_limit: 0,
    total_redeemed: 0,
    overall_utilization_percentage: 0,
    cards_breakdown: []
  },
  uploadedImageId: null,
  addItemConfig: {
    open: false,
    type: null,
    fieldId: null,
    editItem: null
  },
  isEditMode: false,
  preshiftSections: [],
  sectionTypes: [],
  selectedSectionType: null,
  preshiftList: [],
  selectedPreshiftDetail: null,
  cmsRestaurants: [],
  cmsRestaurantDetail: null,
  cmsRestaurantGroups: [],
  cmsRestaurantGroupDetail: null,
  cmsUsersForAssignment: [],
  raffleWinners: [],
  vipCategories: []
}

const superAdmin = createSlice({
  name: "superAdmin",
  initialState: initialState,
  extraReducers: (builder) => builder.addCase(revertAllSuperAdmin, () => initialState),
  reducers: {
    setFrontlineUserID: (state, action) => {
      state.frontlineUser.id = action.payload
    },
    setAdminUserID: (state, action) => {
      state.adminUsers.id = action.payload
    },
    setFrontlineUserList: (state, action) => {
      state.frontlineUser.frontlineUserList = action.payload
    },
    setFrontlineUserData: (state, action) => {
      state.frontlineUser.frontlineUserData = action.payload
    },
    setTotalUserCount: (state, action) => {
      state.totalUserCount = action.payload
    },
    setTotalActiveUser: (state, action) => {
      state.totalActiveUser = action.payload
    },
    setAdminUserList: (state, action) => {
      state.adminUsers.adminUserList = action.payload
    },
    setAdminUserData: (state, action) => {
      state.adminUsers.adminUserData = action.payload
    },
    setDashboardStats: (state, action) => {
      state.dashboardStats = action.payload
    },
    setVersionListData: (state, action) => {
      state.versionListData = action.payload
    },
    setVersionID: (state, action) => {
      state.versionId = action.payload
    },
    setVersiondata: (state, action) => {
      state.versionData = action.payload
    },
    setNotificationList: (state, action) => {
      state.notifications.notificationList = action.payload
    },
    setNotificationID: (state, action) => {
      state.notifications.id = action.payload
    },
    setNotificationData: (state, action) => {
      state.notifications.notificationData = action.payload
    },
    setNotificationImageId: (state, action) => {
      state.notifications.notificationImageId = action.payload
    },
    setGiftCardList: (state, action) => {
      state.giftCards.giftCardList = action.payload
    },
    setGiftCardID: (state, action) => {
      state.giftCards.id = action.payload
    },
    setGiftCardData: (state, action) => {
      state.giftCards.giftCardData = action.payload
    },
    setGiftCardImageId: (state, action) => {
      state.giftCards.giftCardImageId = action.payload
    },
    setGamificationData: (state, action) => {
      state.gamificationData = action.payload
    },
    setEventList: (state, action) => {
      state.eventList = action.payload
    },
    setEventID: (state, action) => {
      state.eventID = action.payload
    },
    setEventDetails: (state, action) => {
      state.eventDetails = action.payload
    },
    setMenuImageList: (state, action) => {
      state.menuImageList = action.payload
    },
    setMenuImage: (state, action) => {
      state.menuImages[action.payload.index] = action.payload.id
    },
    setDownloadMenuTemplate: (state, action) => {
      state.downloadMenuTemplate = action.payload
    },
    setMenuFields: (state, action) => {
      state.menuFields = action.payload
    },
    setNonAiFields: (state, action) => {
      state.nonAiFields = action.payload
    },
    setUserRole: (state, action) => {
      state.userRole = action.payload
    },
    setUserRoleList: (state, action) => {
      state.userRoleList = action.payload
    },
    setUserRoleID: (state, action) => {
      state.userRoleId = action.payload
    },
    setRoleDetails: (state, action) => {
      state.roleDetails = action.payload
    },
    setMenuCategoryDetails: (state, action) => {
      state.menuCategoryDetails = action.payload
    },
    setRecommendationCategoryList: (state, action) => {
      state.recommendationCategoryList = action.payload
    },
    setRecommendedCategoryDetails: (state, action) => {
      state.recommendedCategoryDetails = action.payload
    },
    setHeaderNotificationData: (state, action) => {
      state.headerNotificationData = action.payload
    },
    setTilesList: (state, action) => {
      state.tilesList = action.payload
    },
    setTileDetails: (state, action) => {
      state.tileDetails = action.payload
    },
    setWeeklyCategory: (state, action) => {
      state.weeklyCategory = action.payload
    },
    setWeeklyCategoryImage: (state, action) => {
      state.weeklyCategoryImage.image = action.payload
    },
    setWeeklyCategoryIcon: (state, action) => {
      state.weeklyCategoryImage.icon = action.payload
    },
    setAdvertisements: (state, action) => {
      state.advertisements = action.payload
    },
    setAdvertisementDetails: (state, action) => {
      state.advertisementDetails = action.payload
    },
    setAdvertisementID: (state, action) => {
      state.advertisementId = action.payload
    },
    setPrivacyPolicy: (state, action) => {
      state.privacyPolicy = action.payload
    },
    setNotableVips: (state, action) => {
      state.notableVips = action.payload
    },
    setNotableVipGroups: (state, action) => {
      state.notableVipGroups = action.payload
    },
    setNotableUsers: (state, action) => {
      state.notableUsers = action.payload
    },
    setRewardsPermissions: (state, action) => {
      state.rewardsPermissions = action.payload
    },
    setVipDetails: (state, action) => {
      state.selectedVipDetails = action.payload
    },
    setVipImageId: (state, action) => {
      const { key, id } = action.payload
      state.vipImageIds[key] = id
    },
    removeVipImageId: (state, action) => {
      const { key } = action.payload
      if (state.vipImageIds[key]) {
        delete state.vipImageIds[key]
      }
    },
    resetVipImageIds: (state) => {
      state.vipImageIds = {}
    },
    setNotableGroupTypeId: (state, action) => {
      state.notableGroupTypeId = action.payload
    },
    setAvataarPrompt: (state, action) => {
      state.avataarPrompt = action.payload
    },
    setAvataarEnabled: (state, action) => {
      state.avataarEnabled = action.payload
    },
    setSchemaFields: (state, action) => {
      state.schemaFields = action.payload
    },
    setTiers: (state, action) => {
      state.tiers = action.payload.tiers || []
      state.downgradeEnabled = action.payload.downgrade_enabled || false
    },
    setCategories: (state, action) => {
      state.categories = action.payload
    },
    setCardTypes: (state, action) => {
      state.cardTypes = action.payload
    },
    setRewards: (state, action) => {
      state.rewards = action.payload
    },
    setRewardsSpreeActive: (state, action) => {
      state.rewardsSpreeActive = action.payload
    },
    setSpreeWindowData: (state, action) => {
      state.spreeWindowData = action.payload
    },
    setRedemptions: (state, action) => {
      state.redemptions = action.payload
    },
    setGiftCardRedemptions: (state, action) => {
      state.giftCardRedemptions = action.payload
    },
    setRewardState: (state, action) => {
      state.rewardState = action.payload
    },
    setShoppingSpreeWindows: (state, action) => {
      state.shoppingSpreeWindows = action.payload || []
    },
    setAnalytics: (state, action) => {
      state.analytics = action.payload
    },
    setUploadedImageId: (state, action) => {
      state.uploadedImageId = action.payload
    },
    resetRewardsState: () => initialState,
    setAddItemConfig: (state, action) => {
      state.addItemConfig = { ...state.addItemConfig, ...action.payload }
    },
    setIsEditMode: (state, action) => {
      state.isEditMode = action.payload
    },
    resetAddItemConfig: (state) => {
      state.addItemConfig = initialState.addItemConfig
      state.isEditMode = false
    },
    setSelectedPreshift: (state, action) => {
      state.selectedPreshift = action.payload
    },
    setPreshiftSections: (state, action) => {
      state.preshiftSections = action.payload
    },
    addPreshiftSection: (state, action) => {
      state.preshiftSections.push(action.payload)
    },
    updatePreshiftSection: (state, action) => {
      const index = state.preshiftSections.findIndex((s) => s.id === action.payload.id)
      if (index !== -1) {
        state.preshiftSections[index] = action.payload
      }
    },
    deletePreshiftSection: (state, action) => {
      state.preshiftSections = state.preshiftSections.filter((s) => s.id !== action.payload)
    },
    setSectionTypes: (state, action) => {
      state.sectionTypes = action.payload
    },
    setSelectedSectionType: (state, action) => {
      state.selectedSectionType = action.payload
    },
    setPreshiftList: (state, action) => {
      state.preshiftList = action.payload
    },
    setSelectedPreshiftDetail: (state, action) => {
      state.selectedPreshiftDetail = action.payload
    },
    // ─── Restaurant Management (CMS) ───────────────────────────────────────
    setCMSRestaurantList: (state, action) => {
      state.cmsRestaurants = action.payload
    },
    setCMSRestaurantDetail: (state, action) => {
      state.cmsRestaurantDetail = action.payload
    },
    setCMSRestaurantGroupList: (state, action) => {
      state.cmsRestaurantGroups = action.payload
    },
    setCMSRestaurantGroupDetail: (state, action) => {
      state.cmsRestaurantGroupDetail = action.payload
    },
    setCMSUsersForAssignment: (state, action) => {
      state.cmsUsersForAssignment = action.payload
    },
    setRaffleWinners: (state, action) => {
      state.raffleWinners = action.payload
    },
    setVipCategories: (state, action) => {
      state.vipCategories = action.payload
    }
  }
})

export default superAdmin
export const superAdminAction = superAdmin.actions
